<app-mobile-location-picker
  [locations]="locations$ | async"
  [selectedLocationId]="selectedLocationId$ | async"
></app-mobile-location-picker>
@let linkLocationId = linkLocationId$ | async;
<mat-nav-list class="glimpse-sidebar main-list">
  <h3 matSubheader>{{ (selectedLocation$ | async)?.name.toUpperCase() }}</h3>
  @if (!(isTheOne$ | async)) {
    <a
      mat-list-item
      routerLinkActive="active"
      [routerLink]="['/locations', linkLocationId, 'overview']"
      (click)="closeSidebar('location-report')"
    >
      <div class="link">
        <mat-icon color="primary" fontSet="material-icons-outlined">dashboard</mat-icon>
        {{ 'Overview' | translate }}
      </div>
    </a>
  }
  <a mat-list-item routerLinkActive="active" [routerLink]="['/locations', linkLocationId, 'audits']" (click)="closeSidebar('daily-reports')" tabindex="0">
    <div class="link">
      <mat-icon color="primary" fontSet="material-icons-outlined">linked_camera</mat-icon>
      {{ 'Video Audits' | translate }}
    </div>
  </a>
  @if ((selectedLocationId$ | async) === 1138 && (cctvEnabled$ | async)) {
    <a
      mat-list-item
      routerLinkActive="active"
      [routerLink]="['/locations', linkLocationId, 'cctv']"
      (click)="closeSidebar('cctv')"
      tabindex="0"
    >
      <div class="link">
        <mat-icon color="primary" fontSet="material-icons-outlined">personal_video</mat-icon>
        {{ 'Camera Events' | translate }}
      </div>
    </a>
  }

  <h3 matSubheader>{{ 'Insights' | translate }}</h3>
  <a mat-list-item routerLinkActive="active" [routerLink]="['/locations', linkLocationId, 'analytics', 'employees']" (click)="closeSidebar('employee-analytics')">
    <div class="link">
      <mat-icon color="primary" fontSet="material-icons-outlined">people</mat-icon>
      {{ 'Employees' | translate }}
    </div>
  </a>
  @if ((isSubwayCustomer$ | async) !== 'subway') {
    <a
      mat-list-item
      routerLinkActive="active"
      [routerLink]="['/locations', linkLocationId, 'analytics', 'sales']"
      (click)="closeSidebar('sales-analytics')"
    >
      <div class="link">
        <mat-icon color="primary" fontSet="material-icons-outlined">monetization_on</mat-icon>
        {{ 'Sales' | translate }}
      </div>
    </a>
  }
  @if (staffingEnabled$ | async) {
    <a
      mat-list-item
      routerLinkActive="active"
      [routerLink]="['/locations', linkLocationId, 'analytics', 'staffing']"
      (click)="closeSidebar('staffing-analytics')"
    >
      <div class="link">
        <mat-icon color="primary" fontSet="material-icons-outlined">bar_chart</mat-icon>
        {{ 'Staffing' | translate }}
      </div>
    </a>
  }

  @if ((isSubwayCustomer$ | async) !== 'subway') {
    <h3 matSubheader>{{ 'Inventory' | translate }}</h3>
    <a mat-list-item href="https://inventoryapp.glimpsecorp.com/" target="_blank" rel="noopener" class="cta-menu-item">
      <div class="link">
        <mat-icon color="primary">content_paste</mat-icon>
        <span>
          {{ 'Inventory app' | translate }} <b>{{ 'Get Started' | translate }}</b>
        </span>
      </div>
    </a>
  }
  <h3 matSubheader>{{ 'Referral program' | translate }}</h3>
  <a mat-list-item href="https://www.glimpsecorp.com/referral-program/" target="_blank" rel="noopener" class="cta-menu-item">
    <div class="link">
      <mat-icon color="primary">redeem</mat-icon>
      <span>
        {{ 'Referral program' | translate }} <b>{{ 'Learn More' | translate }}</b>
      </span>
    </div>
  </a>
  <a mat-list-item href="https://www.glimpsecorp.com/partner-program/" target="_blank" rel="noopener" class="cta-menu-item">
    <div class="link">
      <mat-icon color="primary">group_work</mat-icon>
      <span>
        {{ 'Partnership program' | translate }} <b>{{ 'Learn More' | translate }}</b>
      </span>
    </div>
  </a>

  <h3 matSubheader>{{ 'Tools & Support' | translate }}</h3>
  <a mat-list-item (click)="showOnboarding()">
    <div class="link">
      <mat-icon color="primary" fontSet="material-icons-outlined">quiz</mat-icon>
      {{ 'About Glimpse' | translate }}
    </div>
  </a>
  <a mat-list-item (click)="openFeedbackDialog()">
    <div class="link">
      <mat-icon color="primary" fontSet="material-icons-outlined">feedback</mat-icon>
      {{ 'Send us feedback' | translate }}
    </div>
  </a>
</mat-nav-list>
